import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { DeleteTemplatesMutation, DeleteTemplatesMutationVariables } from '@/graphql/generated/graphql';
import { DeleteTemplatesDocument } from '@/graphql/generated/graphql';
export type DeleteTemplateInput = {
  ItemId: string
  isHardDelete?: boolean
}

export type DeleteTemplateResponse = {
  data: {
    deleteTemplates: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useDeleteTemplate = () => {
  const mutation = useMutation({
    mutationKey: ['delete-template'],
    mutationFn: ({ ItemId, isHardDelete = false }: DeleteTemplateInput) => {
      return graphqlClient.request<DeleteTemplatesMutation>(DeleteTemplatesDocument,
        { ItemId, isHardDelete }
      )
    }
  })

  return {
    ...mutation,
    deleteTemplate: mutation.mutate,
    deleteTemplateAsync: mutation.mutateAsync,
  }
}

export const DELETE_TEMPLATE_MUTATION = DeleteTemplatesDocument;
